var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 772"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 227",
    x: 2.78906,
    y: 5.57812,
    width: 15.3398,
    height: 12.5508,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1562 22.3125C13.3627 22.3125 15.5197 21.6582 17.3543 20.4323C19.189 19.2065 20.6189 17.4641 21.4633 15.4256C22.3077 13.387 22.5286 11.1439 22.0981 8.97978C21.6677 6.81568 20.6051 4.82782 19.0449 3.26759C17.4847 1.70737 15.4968 0.644835 13.3327 0.214369C11.1686 -0.216097 8.92547 0.00483387 6.88694 0.849224C4.8484 1.69361 3.10603 3.12354 1.88017 4.95817C0.654302 6.79281 0 8.94975 0 11.1563C0 14.1151 1.17539 16.9527 3.26759 19.0449C5.35979 21.1371 8.19743 22.3125 11.1562 22.3125ZM5.36514 11.4504C5.55516 11.2615 5.81222 11.1554 6.08016 11.1554C6.34809 11.1554 6.60515 11.2615 6.79517 11.4504L9.12784 13.783L15.0001 7.9108C15.1941 7.74464 15.4437 7.65782 15.6989 7.66768C15.9542 7.67754 16.1963 7.78336 16.3769 7.96398C16.5576 8.1446 16.6634 8.38673 16.6732 8.64198C16.6831 8.89724 16.5963 9.14681 16.4301 9.34083L9.83778 15.9332C9.64776 16.122 9.39071 16.2281 9.12277 16.2281C8.85483 16.2281 8.59778 16.122 8.40775 15.9332L5.36514 12.8905C5.27008 12.7963 5.19463 12.6841 5.14314 12.5605C5.09165 12.4369 5.06514 12.3043 5.06514 12.1705C5.06514 12.0366 5.09165 11.904 5.14314 11.7804C5.19463 11.6568 5.27008 11.5447 5.36514 11.4504Z",
    fill: "#15A452"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d123d05466ef80a1aadacd97f59274a8.svg";
export { ForwardRef as ReactComponent };